import './TimeSlotList.css';
export default {
    "accordionListWrapper": "TimeSlotList_accordionListWrapper__1eh59",
    "showTimeItem": "TimeSlotList_showTimeItem__1eh59",
    "selected": "TimeSlotList_selected__1eh59",
    "disabled": "TimeSlotList_disabled__1eh59",
    "soldOut": "TimeSlotList_soldOut__1eh59",
    "signalTextWrapper": "TimeSlotList_signalTextWrapper__1eh59",
    "signalTextContainer": "TimeSlotList_signalTextContainer__1eh59",
    "textWrapper": "TimeSlotList_textWrapper__1eh59",
    "disableItem": "TimeSlotList_disableItem__1eh59",
    "disableText": "TimeSlotList_disableText__1eh59",
    "enableText": "TimeSlotList_enableText__1eh59",
    "iconSignal": "TimeSlotList_iconSignal__1eh59",
    "signalConditionalWrapper": "TimeSlotList_signalConditionalWrapper__1eh59"
};
